var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"h_01",attrs:{"id":"home"}},[_c('m-img',{attrs:{"src":require("@/v2/mobile/assets/image/h_01.jpg")}}),_c('VideoMask',{attrs:{"videoSrc":_vm.videoSrc}},[_c('m-img',{staticClass:"video_play",attrs:{"src":require("@/v2/mobile/assets/image/video_play.svg"),"poster":"@/v2/mobile/assets/video/poster/v_0.webp"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }